<template>
  <div>
    <div class="content-title">
      <div>
        <span>C.E. 1997 - 2020</span>
        <h2>台豬解封</h2>
      </div>
    </div>
    <div class="content-img">
      <picture>
        <source srcset="../../assets/images/o-taiwan/o-taiwan-m.png" media="(max-width: 480px)">
        <img src="../../assets/images/o-taiwan/o-taiwan.png" alt="">
      </picture>
    </div>
    <div class="wrapper">
      <p style="text-align: center"><small>撰文/陳亭均</small></p>
      <p>2020年6月16日，世界動物衛生組織（OIE）正式把台灣從口蹄疫疫區除名。那天晚上，行政院農業委員會動植物防疫檢疫局局長杜文珍開心地幾乎睡不著覺。</p>
      <p>2018年，防檢局前副局長施泰華因主動脈剝離逝世，當時非洲豬瘟正在中國擴散，這個從口蹄疫、H5N6禽流感，一路跟著台灣動植物防疫檢疫走過來的老將，在臨終前都還心心念念著防堵疫情。</p>
      <p>「拿到OIE認可口蹄疫除疫後，我特別找了時間，去施泰華靈前告訴他：『施副局長，您的心願我們完成了……』」也難怪杜文珍感概，口蹄疫是糾纏台灣四分之一個世紀的夢魘。世代手把手，才做完了這道習題。</p>
      <div class="article-media">
        <iframe
            src="https://www.youtube.com/embed/0bOIfhnmnWs"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
      </div>
      <p><br></p>
      <p>回到1997年3月，豬農劉錦河到新竹的豬舍巡視。然而一到那兒，他就知道壞事發生了。「我看到一隻小豬死掉......」不只小豬，豬媽媽蹄子也脫落在地，嫩骨外露。</p>
      <p>官方派來了一個「姓陳什麼的博士。」想起那段往事，劉錦河語氣沉了下來，「一看，他就說這些豬患上了水疱病，要我馬上用鹼片消毒。」他記不起那位博士叫什麼，接下來發生的事，卻讓他想忘也忘不了。</p>
      <p>入夜後，豬舍兩千頭大小豬開始瘋狂尖叫、四處奔跑！「那種聲音，真要形容的話，就是『鬼哭神嚎』！牠們因為痛，蹄子掉了還起身跑，腿上的骨頭全都露了出來。」</p>
      <p>第二天，映入眼簾的是遍地血跡的豬舍，豬腳裸露著白森森的骨頭，「兩百多頭死掉了。」而剛加入家畜衛生實驗所的年輕助理研究員杜文珍，也歷經了一樣的震撼。她從剛送到家畜所的初生仔豬身上，驗出了教科書上寫的世紀黑死病「口蹄疫」。</p>
      <figure class="article-img">
        <img src="../../assets/images/o-taiwan/pic-05.png" alt="">
        <figcaption>雲林縣豬隻圍欄電擊撲殺。</figcaption>
      </figure>
      <p>首例確診，豬繼續運，產業還沒警覺，兩、三天後台灣豬業幾乎全面淪陷。1996年，台灣養豬戶計25,357戶，豬隻總數超過一千萬，平均將近每兩個台灣人就養一頭豬。然而口蹄疫直接殺死了產業和活豬。感染豬場必須全面撲殺，豬屍迅速掩埋，面對疫情，已經沒有容情的空間。數月間，台灣就撲殺了385萬頭豬。</p>
      <p>因為口蹄疫，一年內，國家整體經濟損失高達一千七百多億，豬價更從每百公斤四千元腰斬，逼著五千多戶豬農倒閉。台灣本來是亞洲外銷豬肉大國，每年約產值五百億的豬肉外銷日本，這場「豬的大屠殺」，卻讓養豬王國一夕之間像雅馬遜河畔消失的偉大古文明那樣，蒸發殆盡。</p>
      <p><br></p>
      <p>回到口蹄疫流行期間，那時全國上下可能全都處在一個少了一根筋、缺少危機感的輕慢狀態。1996年，中國、香港、越南、菲律賓都已傳出口蹄疫大流行，豬農、台商往來依舊頻繁。更早前，養豬協會已經提醒過農委會，中國正在走私來台。</p>
      <p>豬農劉錦河當年在自家豬場空地，更曾目睹二十噸卡車載著走私豬肉占場交易。走私豬肉很可能就是台灣疫情大爆發的元凶。</p>
      <p>1998年防檢局擬定「口蹄疫撲滅計畫」，豬戶需配合施打疫苗、從防檢局下到縣市地方不斷機動查核。當年台灣豬隻開始全面施打疫苗，疫情才暫時控制住，但即使打疫苗，也不代表病毒就此消失，台灣成為口蹄疫疫區，豬肉難以外銷。</p>
      <figure class="article-img">
        <img src="../../assets/images/o-taiwan/pic-01.png" alt="">
        <figcaption>「豬病之神」賴秀穗對動物防疫非常專業，更長年擔任針砭政策的民間專家，提供政府強而有力的建言。</figcaption>
      </figure>
      <p>2006年台灣嘗試行地區性和階段性拔針停打疫苗，2009年卻突然出現零星個案，最後只好繼續施打疫苗。直到2018年，才再度停止施打疫苗，滿一年後終於符合向OIE申請不施打疫苗非疫區的資格。</p>
      <figure class="article-img">
        <img src="../../assets/images/o-taiwan/pic-02.png" alt="">
        <figcaption>杜文珍擔任助理研究員期間，從剛送到家畜所的初生仔豬身上驗出口蹄疫。</figcaption>
      </figure>
      <p>杜文珍一路隨著台灣豬產業從低谷走到現在，她現在已是防檢局局長。2018年，非洲豬瘟在中國蔓延，政府馬上定調這是「國安級別」的大事，「豬瘟是還沒來，我們就開始連結所有部會。」她笑說，因為口蹄疫的教訓，非洲豬瘟爆發時，「民眾都在喊『守護滷肉飯！』我們真的被感動，也被鼓舞了！」</p>
      <p>而到了2020年，農委會也迅速向OIE發出申請。然而今年新冠肺炎肆虐，OIE年會延期。杜文珍和防檢局不斷斡旋，最後才爭取到以遠距視訊會議等方式代替，2020年6月16日獲得OIE同意宣告台灣（台、澎、馬）改列不打疫苗的非疫區，唯金門尚未拔針。台灣正式擺脫口蹄疫疫區的標籤。</p>
      <figure class="article-img">
        <img src="../../assets/images/o-taiwan/pic-03.png" alt="">
        <figcaption>新合興牧場內的小豬活力十足，在優秀的生物安全體系中安心成長。</figcaption>
      </figure>
      <p>不僅官方，因為口蹄疫和國際疫病接連撲台，國內豬農觀念也逐漸改變。</p>
      <p>位在南投的新合興牧場，生物安全防護做得幾乎滴水不漏。員工、訪客皆須洗頭、洗澡，換上專用的衣物才能進場。「在生物安全上，包括運輸車輛、器具進出，都會要求。」總經理林陽山很清楚，「螺絲鬆掉，一批小豬可能就會因下痢問題，造成許多損失。」</p>
      <p>口蹄疫在台灣絕跡，但不代表未來台灣豬業王國就能中興。1997年之前的養豬盛況已不復見，台灣目前養豬戶跟當年全盛時期的豬量相比，幾乎腰斬一半。如果台灣豬要再出口，未來勢必要重建規格化生產流程及屠體評等制度，加上尚未拔針的「傳統豬瘟」..，全部都是挑戰。然而國門守好、家門守好，品質優化，儘管台灣許多養豬場仍維持傳統樣貌，但從政府到業界，改變正在加速。</p>
      <figure class="article-img">
        <img src="../../assets/images/o-taiwan/pic-04.png" alt="">
        <figcaption>2020年台灣獲OIE同意，正式擺脫口蹄疫疫區的標籤。</figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
